export default __webpack_public_path__ + "static/media/connections.c9256677.svg";